var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._g({staticClass:"mr-2",attrs:{"variant":"outline-info","size":"sm"}},_vm.$listeners),[_c('b-icon',{attrs:{"icon":_vm.icon,"small":""}}),(_vm.$slots.default)?_c('span',{staticClass:"ml-1"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }